<template>
  <RouterViewer />
  <IdleModal v-if="userStore.username && !userStore.isWebshop" />
  <ImpersonationIndicator />
  <Toasts />
  <StickyPhoneWidget />
  <CookieConsent />
  <CartDrawer v-if="!isB2C" />
</template>
<script setup>
import { IdleModal } from "@/components/sign-in";
import { inject } from "vue";
import { useUserStore } from "@/store/user";
import brandconfig, { isB2C } from "@/brandconfig";
import { ImpersonationIndicator } from "@xs2event/js-lib/impersonation";
import { Toasts } from "@xs2event/js-lib/toast";
import { useVersionChecker } from "@xs2event/js-lib/util";
import "@xs2event/js-lib/style";
import { api } from "@/helpers/api";
import RouterViewer from "@/pages/RouterViewer.vue";
import StickyPhoneWidget from "@/components/page/StickyPhoneWidget.vue";
import CookieConsent from "@/components/shared/CookieConsent.vue";
import CartDrawer from "@/components/cart/CartDrawer.vue";
import { useRouter } from "vue-router";

const userStore = useUserStore();
const router = useRouter();

useVersionChecker({
  api,
  projectSlug: "xs2event-portal-v2",
  router,
});

userStore.init();

if (brandconfig.GA_ID) {
  inject("gtag");
}
</script>
